import React from "react"
import {graphql, useStaticQuery} from "gatsby"
import Slider from "react-slick"
import styled, { css } from "styled-components"
import ContainerMax from "components/shared/ContainerMax"
import ContentMax from "components/shared/ContentMax"
import CarouselStyled from "components/shared/CarouselStyled"
import NewsPreview from "components/shared/NewsPreview"
import WPLink from "components/shared/WPLink"
import BlockTitle from "components/shared/BlockTitle"
import CarouselPrevButton from "components/shared/CarouselPrevButton"
import CarouselNextButton from "components/shared/CarouselNextButton"
import { media } from "utils/Media"

const Background = styled.div`
	background-color: ${props => props.theme.colors.primary};
	padding-top: 2rem;
	padding-bottom: 2rem;
	${props => props.background === "colour" && css`
		background-image: ${props => props.theme.colors.gradient};
	`}
`

const ContainerMaxStyled = styled(ContainerMax)`
  padding-right: 0;
	overflow: hidden;
	@media ${media.md} {
		padding-right: ${props => props.theme.bootstrapGutterWidth};
	}

	@media (min-width: 1300px) {
		overflow: visible;
	}
`

const NewsCarousel = (props) => {
	const data = useStaticQuery(graphql`
	query {
		allWpNewsArticle(sort: {order: DESC, fields: date}, limit: 12, filter: {status: {eq: "publish"}}) {
			edges {
				node {
					uri
					title
					date
					acfNews {
						hidePublishDate
						newsYoutube
						featuredImage45 {
							altText
							localFile {
								childImageSharp {
									gatsbyImageData(width: 536, quality: 85, placeholder: NONE, layout: CONSTRAINED)
								}
							}
						}
					}
				}
			}
		}
	}`)

	const { block } = props
	const posts = data.allWpNewsArticle.edges

	const getNews = posts && posts.map((post, i) => {
		return <NewsPreview data={post} key={i} borderOnHover={block.borderOnHover} />
	})

	const settings = {
		dots: true,
		infinite: false,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		lazyload: false,
		prevArrow: <CarouselPrevButton/>,
		nextArrow: <CarouselNextButton/>,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '60px'
				}
			}
		]
	}

	return (
		<Background background={block.background}>
			<ContainerMaxStyled>
				<ContentMax>
					<CarouselStyled background={block.background} itemCount={posts.length}>
						{block.title &&
							<BlockTitle 
								dangerouslySetInnerHTML={{__html: block.title }} 
								white={block.background === "colour" ? true : false}
								outline={block.background === "colour" ? true : false}
								color="black"
							/>
						}

						<Slider {...settings}>
							{getNews}
						</Slider>
				
						{/*do we have a view all link?*/}
						{block.button &&
							<div className="pt-3 mx-auto text-center">
								<WPLink url={block.button.url} target={block.button.target} button color="white">
									{block.button.title}
								</WPLink>
							</div>
						}
					</CarouselStyled>
				</ContentMax>
			</ContainerMaxStyled>
		</Background>
	)
}

export default NewsCarousel